import React from 'react';
import { Button, Icon } from '../../components';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { getRecommendedBannerClicked } from '../../utils/clicktrackingManager';

export default class CollegeEventsAnnouncement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEventsAnnouncement: true,
    };
  }

  onClick = (value) => {
    this.setState({ showEventsAnnouncement: false });
    this.props.handleClickTracking(getRecommendedBannerClicked());
    this.props.filterByRecommended(value, true, true);
  };

  getMessage = (count) => {
    return `There ${count > 1 ? 'are' : 'is'} ${count} event${count > 1 ? 's' : ''} at which colleges are looking for students like you!`;
  };

  render() {
    const { recommendedEventsCount } = this.props;
    const msg = recommendedEventsCount ? this.getMessage(recommendedEventsCount) : '';

    return recommendedEventsCount && this.state.showEventsAnnouncement ? (
      <div className="college-events-announcement">
        <div className="container">
          <div className="announcement-toast">
            <strong>Great news! </strong>
            {msg}
          </div>
        </div>
        <Button
          compact
          basic
          size="tiny"
          className="recommended-events"
          inverted
          onClick={() => {
            this.onClick(true);
          }}
        >
          <Icon className="flag-icon" name="flag" />
          <FormattedMessage {...messages.seerecommendedevents} />
        </Button>
        <Icon name="close" inverted className="close-event-announcement" onClick={() => this.setState({ showEventsAnnouncement: false })} />
      </div>
    ) : null;
  }
}
